import React, { useState } from "react";
import { Grid, TextField, Checkbox, FormControlLabel, Box, Typography, Divider, Container } from "@mui/material";
import { date_availability_fields } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function ApplicableDate({ value, setValue }) {
	// State variables
	const [days, setDays] = useState({});

	return (
		<Box p={3} width="90%">
			<Divider>
				<Typography variant="h6">Applicable Dates</Typography>
			</Divider>
			<Box display="flex" columnGap={1} rowGap="10px" flexWrap="wrap" width={"100%"} justifyContent={"space-between"}>
				{date_availability_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="32%"
							selectOptObjName={"option_data"}
							key={row.key}
						/>
					);
				})}
			</Box>
			{/* Applicable Days */}
			<Grid item xs={12} pl={6} pt={2}>
				<Typography variant="subtitle2" pb={2} pt={1}>
					Applicable Days
				</Typography>
				<Grid container spacing={1}>
					{["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day, index) => (
						<Grid item xs={3} key={day}>
							<FormControlLabel
								control={
									<Checkbox
										checked={value.applicable_date.applicable_days.includes(day)}
										onChange={() => {
											const currentDays = value.applicable_date.applicable_days;
											const updatedDays = currentDays.includes(day)
												? currentDays.filter((d) => d !== day)
												: [...currentDays, day];

											setValue((prev) => ({
												...prev,
												applicable_date: {
													...prev.applicable_date,
													applicable_days: updatedDays,
												},
											}));
										}}
									/>
								}
								label={day}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Box>
	);
}

export default ApplicableDate;
